import { useQuery } from "@tanstack/react-query";
import api from "../../../services/api";
import { tagsQueryKeys } from "../queryKeys";

const useGetSystemTags = (hash: string) => {
  const { data, isPending } = useQuery({
    queryKey: [tagsQueryKeys.getSystemTags(hash)],
    queryFn: () => api.getSystemTags(hash),
    select: ({ data: selectData }) =>
      selectData.map(({ tag }: { tag: string }) => tag)
  });

  return { data, isLoading: isPending };
};

export default useGetSystemTags;
